import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { InventoryWarehousePage } from '@/features/inventory'

export const Route = createFileRoute('/_authenticated/inventory/warehouse')({
  component: () => (
    <RequirePermission permission='inventory_approve.update'>
      <InventoryWarehousePage />
    </RequirePermission>
  ),
})
